import { create } from 'zustand';
import type { DayPrediction } from '../types';
import type { SogralDestination } from '../types/sogral';
import type { DepartureDetail } from '../services/predictionService';

interface SearchStore {
  // SOGRAL data
  destinations: SogralDestination[];
  agencyId: number;
  destinationId: string;
  date: string;

  // Results
  loading: boolean;
  prediction: DayPrediction | null;
  departures: DepartureDetail[];
  error: string | null;
  dataSource: 'live' | 'mock' | null;

  // Actions
  setDestinations: (d: SogralDestination[]) => void;
  setAgencyId: (id: number) => void;
  setDestinationId: (id: string) => void;
  setDate: (date: string) => void;
  setLoading: (loading: boolean) => void;
  setPrediction: (prediction: DayPrediction | null, departures?: DepartureDetail[], source?: 'live' | 'mock') => void;
  setError: (error: string | null) => void;
}

function todayStr(): string {
  return new Date().toISOString().split('T')[0];
}

export const useSearchStore = create<SearchStore>((set) => ({
  destinations: [],
  agencyId: 0,
  destinationId: '',
  date: todayStr(),
  loading: false,
  prediction: null,
  departures: [],
  error: null,
  dataSource: null,

  setDestinations: (destinations) => set({ destinations }),
  setAgencyId: (agencyId) => set({ agencyId, prediction: null, error: null }),
  setDestinationId: (destinationId) => set({ destinationId, prediction: null, error: null }),
  setDate: (date) => set({ date, prediction: null, error: null }),
  setLoading: (loading) => set({ loading }),
  setPrediction: (prediction, departures = [], source = 'mock') =>
    set({ prediction, departures, dataSource: source, loading: false, error: null }),
  setError: (error) => set({ error, loading: false }),
}));
